import { apiSlice } from "./apiSlice";

export const warehousingSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({

        getAllWarehousing: builder.query({
            query: (params) => ({
                url: `WarehouseLease`,
                params,
            }),
            keepUnusedDataFor: 0,
            refetchOnMountOrArgChange: true,
            providesTags: ["WarehousingTracker"],
        }),

        createWarehousing: builder.mutation({
            query: ({ body }) => ({
                url: `WarehouseLease`,
                method: "POST",
                body,
            }),
            invalidatesTags: ["WarehousingTracker"],
        }),

        updateWarehousing: builder.mutation({
            query: ({ body }) => ({
                url: `WarehouseLease`,
                method: "PUT",
                body,
            }),
            invalidatesTags: ["WarehousingTracker"],
        }),

        getExportWarehousing: builder.query({
            query: (params) => ({
                url: `WarehouseLease`,
                params,
            }),
            keepUnusedDataFor: 0,
        }),

    }),
});

export const { useLazyGetAllWarehousingQuery, useCreateWarehousingMutation, useUpdateWarehousingMutation, useLazyGetExportWarehousingQuery } = warehousingSlice;